<template>
    <v-card color="#F4FEFB">
        <v-card-title>
            印影の設定
        </v-card-title>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-select
                :items="selectDestinations"
                label="入力者"
                outlined
                hide-details
                v-on:change="changeUserId"
                v-model="selected"
                background-color="white"
              >
              </v-select>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
export default {
    props: ['destinations', 'destinationId'],
    data: function () {
        return {
            selectDestinations: [],
            selected: 0,
        }
    },
    created: function () {
        this.selected = this.destinationId
        Object.entries(this.destinations).forEach((val, index) => {
            this.selectDestinations.push({
                text: val[1].destination_user_name,
                value: val[1].id
            })
        })
    },
    methods: {
        changeUserId: function (e) {
            this.$emit('changeUserId', e)
        }
    }
}
</script>

<style scoped>

</style>